import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import LoadingOverlay from 'react-loading-overlay';
import { getExpressParams } from '../../../service/api';

const CustomResult = (props) => {
  const [loaded, setLoaded] = useState(true);
  const [loadingText, setLoadingText] = useState(<div>loading</div>);
  const [reportResultArr, setReportResultArr] = useState([]);
  const [queryData, setQueryData] = useState(null)

  useEffect(() => {
    setLoaded(false);
    handleLoadingText();

    getExpressParams(`/query/custom/customid`, {
      email: props.currentUser,
      customID: props.match.params.customID
    }, (response) => {
      let count = 0;
      let reportArr = response.data;
      reportArr.forEach((reportItem, index) => {
        count = count + 1;
        let jsonQueryArray = [];
        let options = {
          timeunit: 'daily',
          datatype: 'numeric',
          rows: '50',
          words: '200',
          morph: 'all',
          buzzRows: '10'
        };

        getExpressParams('/query/report-content/userid/reportid', {
          email: props.currentUser,
          reportID: reportItem.reportID
        }, (reportRes) => {
          options.timeunit = JSON.parse(reportRes.data.reportentity[0].content).timeunit;
          options.datatype = JSON.parse(reportRes.data.reportentity[0].content).datatype;
          options.rows = JSON.parse(reportRes.data.reportentity[0].content).rows;
          options.words = JSON.parse(reportRes.data.reportentity[0].content).words;
          options.morph = JSON.parse(reportRes.data.reportentity[0].content).morph;
          options.buzzRows = JSON.parse(reportRes.data.reportentity[0].content).buzzRows;
          // mainQuery: response.data.basequery,
          // subQuery: response.data.subquery
          getExpressParams('/query/query-content/userid/queryid', {
            email: props.currentUser,
            queryID: [{queryID: reportRes.data.basequery}, ...reportRes.data.subquery]
          }, (response) => {
            response.data.forEach(item=>{
              jsonQueryArray.push({
                "name": item.name,
                "type": item.QUERY_TYPE,
                "content": JSON.parse(item.content)
              })
            })

            const retJSON = {
              "channel": JSON.parse(reportRes.data.reportentity[0].content).channels,
              "dateRange": JSON.parse(reportRes.data.reportentity[0].content).date,
              "name": reportRes.data.reportentity[0].name,
              "query": jsonQueryArray,
              "reportType": reportRes.data.reportentity[0].REPORT_TYPE,
              "retwit": JSON.parse(reportRes.data.reportentity[0].content).reTweet,
              "sub_query_type": reportRes.data.reportentity[0].function,
            }
            getExpressParams(`/report/${retJSON.reportType}/json`,{
              email: props.currentUser,
              json: JSON.stringify(retJSON)
            }, (resultRes) => {
              count = count - 1;
              if( count == 0 ) {
                setLoaded(true)
                setLoadingText(<div>loadng</div>)
              }
            })
          })
        })
      })
    })

  },[])

  const handleLoadingText = () => {
    setLoadingText(
    <span style={{textAlign: "left"}}>
      <>
      <div>
        Custom Report Loading
      </div>
        {/* <div>
          SubQuery: {outputSubQuery.map((item,index)=>{
            if (index==outputSubQuery.length-1){
              return (`${item}`)
            }
            else return (`${item}, `)
          })}
        </div> */}
      </>
    </span>
    )
  }

  return (
    <LoadingOverlay
      active={!loaded}
      spinner={true}
      text={loadingText}>
      
    </LoadingOverlay>
  )
}

const mapStateToProps = (state) => ({
  currentUser: state.AuthManager.status.currentUser
});

export default connect(mapStateToProps) (CustomResult);